/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_All_PostsInputs */

const en_blog_all_posts = /** @type {(inputs: Blog_All_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All posts`)
};

const pl_blog_all_posts = /** @type {(inputs: Blog_All_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie wpisy`)
};

/**
* | output |
* | --- |
* | "All posts" |
*
* @param {Blog_All_PostsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_all_posts = /** @type {((inputs?: Blog_All_PostsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_All_PostsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_all_posts(inputs)
	return en_blog_all_posts(inputs)
});